module.exports = __webpack_public_path__ + "static/media/gray_animal_insects_5.3faca625.png";